import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotSection from './components/HotSection';
import LatestSection from './components/LatestSection';
import CategoriesSection from './components/CategoriesSection';
import CtaSection from './components/CtaSection';
import { useState, useEffect } from 'react';

export default function Home() {
  const [showBackTop, setShowBackTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackTop(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />

        <article>
          <HotSection />
        </article>

        <article>
          <LatestSection />
        </article>

        <article>
          <CategoriesSection />
        </article>

        <article>
          <CtaSection />
        </article>
      </main>

      <Footer />

      <button
        onClick={scrollToTop}
        className={`fixed bottom-8 right-8 z-40 w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center shadow-lg hover:bg-primary-600 transition-all duration-300 cursor-pointer ${
          showBackTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="回到顶部"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-up-line text-lg"></i>
        </div>
      </button>
    </>
  );
}